module.exports = __webpack_public_path__ + "static/flow-143e0c7774eb7c157054946f4546bb73.png";